export interface ParsedTimeAnswer {
  hour: number;
  minute: number;
  zone?: string;
  local: string;
}

const pad = (n: number) => String(n).padStart(2, "0");

const to24Hour = (hour: number, amPm: string | undefined): number => {
  if (amPm === undefined) return hour;
  if (amPm === "PM") return hour === 12 ? 12 : hour + 12;
  return hour === 12 ? 0 : hour;
};

export const getLocalTimezone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const parseTimeAnswer = (value: string): ParsedTimeAnswer | null => {
  const match = /^(\d{1,2}):(\d{2})(?:\s+(AM|PM))?(?:\s+(\S+))?$/i.exec(value.trim());
  if (!match) return null;

  const rawHour = Number(match[1]);
  const minute = Number(match[2]);
  const amPm = match[3]?.toUpperCase();
  const zone = match[4];

  if (minute > 59) return null;
  if (amPm === undefined) {
    if (rawHour > 23) return null;
  } else if (rawHour < 1 || rawHour > 12) return null;

  const hour = to24Hour(rawHour, amPm);

  return { hour, minute, zone, local: `${pad(hour)}:${pad(minute)}` };
};

export const formatStoredTime = (value: string): string => {
  const parsed = parseTimeAnswer(value);
  if (!parsed) return "";

  const amPm = parsed.hour < 12 ? "AM" : "PM";
  const displayHour = parsed.hour % 12 === 0 ? 12 : parsed.hour % 12;
  return `${displayHour}:${pad(parsed.minute)} ${amPm}`;
};

export const assembleTimeAnswer = (value: string): string | null => {
  const parsed = parseTimeAnswer(value);
  if (!parsed) return null;

  const amPm = parsed.hour < 12 ? "AM" : "PM";
  const displayHour = parsed.hour % 12 === 0 ? 12 : parsed.hour % 12;
  return `${pad(displayHour)}:${pad(parsed.minute)} ${amPm} ${parsed.zone ?? getLocalTimezone()}`;
};
